import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IRecordCompanyFurtherEducationGroups, RecordCompanyFurtherEducationGroups } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";
import { IRecordCompanyRecordFamiliarizationListItems, RecordCompanyRecordFamiliarizationListItems } from "./recordCompanyRecordFamiliarizationListItems";

export interface IRecordPageUnitsAndJobTitles {
    hasExplicitRecordPartners: boolean;
    companyFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
    companyFamiliarizations: IRecordCompanyRecordFamiliarizationListItems[];
    units: IIdTitleNode[];
    jobTitles: string[];
    sheetTaskType: ITaskEditTypeItem;
}

export class RecordPageUnitsAndJobTitles implements IRecordPageUnitsAndJobTitles {
    hasExplicitRecordPartners: boolean;
    companyFurtherEducationGroups: RecordCompanyFurtherEducationGroups[];
    companyFamiliarizations: RecordCompanyRecordFamiliarizationListItems[];
    units: IdTitleNode[];
    jobTitles: string[];
    sheetTaskType: TaskEditTypeItem;

    constructor();
    constructor(obj: IRecordPageUnitsAndJobTitles);
    constructor(obj?: any) {
        this.hasExplicitRecordPartners = obj && obj.hasExplicitRecordPartners || false;
        this.companyFurtherEducationGroups = Base.getTypedArray(obj?.companyFurtherEducationGroups, RecordCompanyFurtherEducationGroups);
        this.companyFamiliarizations = Base.getTypedArray(obj?.companyFamiliarizations, RecordCompanyRecordFamiliarizationListItems);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.jobTitles = obj && obj.jobTitles || [];
        this.sheetTaskType = null;
        if (obj && obj.sheetTaskType) {
            this.sheetTaskType = new TaskEditTypeItem(obj ? obj.sheetTaskType : null);
        }
    }
}